var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3133 12.1479L13.0893 8.9238C12.7638 8.5983 12.2362 8.5983 11.9108 8.9238L5.7208 15.1137C4.26127 13.8908 3.33317 12.0544 3.33317 10.0013C3.33317 6.3194 6.31794 3.33464 9.99984 3.33464C13.6818 3.33464 16.6665 6.3194 16.6665 10.0013C16.6665 10.7523 16.5423 11.4743 16.3133 12.1479ZM9.99984 18.3346C14.6022 18.3346 18.3332 14.6036 18.3332 10.0013C18.3332 5.39893 14.6022 1.66797 9.99984 1.66797C5.39746 1.66797 1.6665 5.39893 1.6665 10.0013C1.6665 14.6036 5.39746 18.3346 9.99984 18.3346ZM9.1665 8.33464C9.1665 9.25514 8.42034 10.0013 7.49984 10.0013C6.57936 10.0013 5.83317 9.25514 5.83317 8.33464C5.83317 7.41416 6.57936 6.66797 7.49984 6.66797C8.42034 6.66797 9.1665 7.41416 9.1665 8.33464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCircleFill);
export default __webpack_public_path__ + "static/media/image-circle-fill.3c865f9985f3eea1c73c1be7822ba4b0.svg";
export { ForwardRef as ReactComponent };